<div class="logo-div">
    <img src="../../../../assets/images/bonds-logo.svg" alt="">
</div>

<div class="maintainence-main">
    <img src="../../../../assets/images/maintainence-screen.svg" alt="">

    <div class="hang-on">
        Hang on! Our site is under maintenance
    </div>

    <div class="paragraph">
        We're performing scheduled maintenance to improve your browsing experience. During this time,
        retailers.worldofsweets.co.uk will be unavailable. We expect everything to be back online by 07:00AM Monday
        morning.
    </div>

    <div class="thank">
        Thank you for your patience!
    </div>
 

</div>